<template>
  <a-layout class='index animated fadeIn'>

    <a-card :bordered='false'>
      <div class="m-t-20 m-b-20 s_flex_bian_c">
        <div>
          <span class='mr15'>
            <a-button type="primary" v-has:qrcodeAntiCreate="()=>{$router.push({path:'/qrcode/template/anti/create',query:{type:'add'}})}">
              <PlusOutlined />
              创建新认证
            </a-button>
            (创建后新模板将不可修改)
          </span>
        </div>
      </div>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
          <template v-slot:member="{ record }">
            <div class="s_flex_ali">
              <img class="width-50 height-50 m-r-15" :src="record.member_img ? record.member_img : ''" alt="" />
              <div>
                <p>{{record.member_name || '-'}}</p>
                <p>ID：{{record.member_id}}</p>
              </div>
            </div>
          </template>
          <template v-slot:code_sn="{ record }">
            <p>{{record.product_code}}</p>
            （{{record.code_sn}}）
          </template>
          <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:qrcodeAntiDetail="()=>{$router.push({path:'/qrcode/template/anti/detail',query:{id:record.id,type:'detail'}})}" class="m-r-15">查看详情</a>
            <a href="javascript:;" v-has:qrcodeAntiDel="()=>del(record)" v-if="record.verify_status!=1">删除</a>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { iscode } from "@/utils/app";
import { antisFakeTem, antisFakeTemDel } from "@/api/qrcode";
import { message, Modal } from "ant-design-vue";
const def = {
  page: 1,
  limit: 10,
  start_time: "",
  end_time: "",
  batch_sn: "",
  remarks: "",
  serial_sn: "",
  code: "",
  activity_id: "",
  product_keyword: "",
  province_id: "",
  city_id: "",
  district_id: "",
  member_keyword: "",
  scan_count: "",
};
export default {
  name: "integralDetail",
  props: {
    type: String,
  },
  setup(props) {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      showEdit: false,
      scan_id: "",
      activityVisible: false,
    });
    let list = ref();

    let columns = [
      {
        title: "认证ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "认证名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "状态",
        key: "verify_status_title",
        dataIndex: "verify_status_title",
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const initData = async (values) => {
      state.listLoading = true;
      let res = await antisFakeTem(values).then((res) => res.data);
      state.listLoading = false;
      list.value = [];
      if (iscode(res)) {
        list.value = res.data;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };

    const del = (data) => {
      Modal.confirm({
        centered: true,
        content: "删除该模板无法恢复",
        onOk: async () => {
          let res = await antisFakeTemDel(data.id).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    onMounted(() => {
      initData(search.value);
    });

    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      changTime,
      inputSelect,
      del,
    };
  },
};
</script>